// L'anneau de six points du shop (components/ui/icons/AiIcon.jsx), repris comme
// marque IA du backoffice : même géométrie, mais FIXE. Le shop l'anime parce
// qu'il y signale une réponse en train de s'écrire ; ici c'est une entrée de
// navigation, permanente à l'écran — un logo qui tourne en continu attire l'œil
// sans jamais rien annoncer.
const SIZE = 24
const CENTER = SIZE / 2
const RING_RADIUS = 7.5
const DOT_RADIUS = 1.35
const DOTS = 6

const DOT_POSITIONS = Array.from({ length: DOTS }, (_, k) => {
    const angle = ((k * (360 / DOTS) - 90) * Math.PI) / 180
    return {
        cx: +(CENTER + RING_RADIUS * Math.cos(angle)).toFixed(3),
        cy: +(CENTER + RING_RADIUS * Math.sin(angle)).toFixed(3),
    }
})

export default function AiRingIcon({ width = SIZE, height = SIZE, ...props }) {
    return (
        <svg
            aria-hidden="true"
            width={width}
            height={height}
            viewBox={`0 0 ${SIZE} ${SIZE}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {DOT_POSITIONS.map(({ cx, cy }, k) => (
                <circle key={k} cx={cx} cy={cy} r={DOT_RADIUS} fill="currentColor" />
            ))}
        </svg>
    )
}
